import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { VolumeApi } from "@/lib/volume-api";
import type { Institution } from "@/types/institutions";
import { createFileRoute } from "@tanstack/react-router";
import { CardWithHeader } from "@/components/card-with-header";

export const Route = createFileRoute(
  "/(app)/_main-layout/_settings/settings/institutions",
)({
  component: () => <InstitutionsComponent />,
  loader: ({ context: { selectedApplicationId } }) => {
    const api = new VolumeApi("", selectedApplicationId);
    return api.getInstitutions();
  },
});

function InstitutionsComponent() {
  const institutions = Route.useLoaderData();
  return (
    <CardWithHeader variant="exchange" title="Institutions" noChildPadding>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="">Full Name</TableHead>
            <TableHead>Logo</TableHead>
            <TableHead>Icon</TableHead>
            <TableHead>Id</TableHead>
            <TableHead>Environment Type</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {institutions.map((institution) => (
            <TableRowContent content={institution} key={institution.id} />
          ))}
        </TableBody>
      </Table>
    </CardWithHeader>
  );
}

function TableRowContent({ content }: { content: Institution }) {
  return (
    <TableRow>
      <TableCell className="font-medium">{content.name}</TableCell>
      <TableCell>
        <img
          width={80}
          height={80}
          src={
            content.media.find((media) => media.type === "logo")?.source ?? "" // TODO: Add default image
          }
          alt="Institution logo"
        />
      </TableCell>
      <TableCell>
        <img
          width={25}
          height={25}
          alt="Institution icon"
          src={
            content.media.find((media) => media.type === "icon")?.source ?? "" // TODO: Add default image
          }
        />
      </TableCell>
      <TableCell>{content.id}</TableCell>
      <TableCell>
        <div
          className={cn(
            "inline-block rounded-xl border border-current/15 px-2 py-[2px] text-center",
            content.environmentType === "LIVE" &&
              "bg-emerald-100 text-emerald-800",
            content.environmentType === "SANDBOX" &&
              "bg-violet-100 text-violet-800",
          )}
        >
          {content.environmentType.charAt(0).toUpperCase() +
            content.environmentType.slice(1).toLowerCase()}
        </div>
      </TableCell>
    </TableRow>
  );
}
